import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { CreateOrEditCustomRule, CreateOrEditManufacturerRule, SpinCentered } from '@/comp';
import { permissions } from '@/constants';
import { useStores } from '@/hooks/use-stores';

const RuleEditPage = observer(() => {
  const { ruleType, id } = useParams();
  const { stationStore, rulesStore, devicesStore, permissionStore } = useStores();
  const navigate = useNavigate();
  const [rule, setRule] = useState();

  useEffect(() => {
    // avoid viewing alert without proper permissions
    if (!permissionStore.isAuth(permissions.VIEW_STATION_ALERTS)) {
      navigate('/home/station');
    }
  }, []);

  useEffect(() => {
    if (!id) return;
    if (!stationStore.currentStation.id) return;

    async function fetchRule() {
      const newRule = await rulesStore.getById(id, ruleType);
      setRule(newRule);
    }

    fetchRule();

    // clean up in case of insufficient permissions
    return rulesStore.cancelGetById;
  }, [stationStore.currentStation.id, id]);

  useEffect(() => {
    if (!stationStore.currentStation.id) return;
    if (devicesStore.isReady) return;

    devicesStore.getDevicesMetadata();
  }, [stationStore.currentStation.id]);

  const isReady = () => {
    return rule && devicesStore.isReady;
  };

  return isReady() ? (
    <>
      {ruleType === 'custom' && <CreateOrEditCustomRule rule={rule} />}
      {ruleType === 'manufacturer' && <CreateOrEditManufacturerRule rule={rule} setRule={setRule} />}
    </>
  ) : (
    <SpinCentered />
  );
});

export default RuleEditPage;
